import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectCashierPageRoutingModule } from './select-cashier-routing.module';

import { SelectCashierPage } from './select-cashier.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SelectCashierPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [SelectCashierPage]
})
export class SelectCashierPageModule {}
